import { RootState } from "@/redux/store";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "sonner";
import * as API from "../@api/update";
import { Actions } from "./slice";

export const updateBusinessDetails = createAsyncThunk<
  any,
  FormData,
  { state: RootState }
>(
  "businessDetails/updateBusinessDetails",
  async (formValue, { rejectWithValue, dispatch }) => {
    try {
      const response: any = await API.addBusinessDetails(formValue);

      toast.success(response?.meta?.message as string, {
        classNames: {
          toast: "!bg-green-500 !text-white",
        },
      });
      dispatch(Actions.setFormValues(null));

      return null;
    } catch (error: any) {
      toast.error(error?.meta?.message as string, {
        classNames: {
          toast: "!bg-red-500 !text-white",
        },
      });
      return rejectWithValue(error?.response?.data || error?.message);
    }
  }
);

export const thunks = {
  updateBusinessDetails,
};